export const SEARCH_ALL = 'ALL';
export const SEARCH_COMMUNITY_POSTS = 'COMMUNITY_POSTS';
export const SEARCH_COMMUNITY_GROUPS = 'COMMUNITY_GROUPS';
export const SEARCH_COMMUNITY_PEOPLE = 'COMMUNITY_PEOPLE';
export const SEARCH_INSTITUTIONS = 'INSTITUTIONS';

export const SEARCH_CATEGORY_SELECTED = 'SEARCH_CATEGORY_SELECTED';

export const KEY_ARROW_UP = 38;
export const KEY_ARROW_DOWN = 40;
export const KEY_ARROW_RIGHT = 39;
export const KEY_ARROW_LEFT = 37;
export const KEY_ENTER = 18;
